<template>
  <div class="integracion-expediente-principal" style="flex-grow: 1">
    <div class="layer-loader" v-if="redirigiendoIncode">
      <div class="layer-loader-spinner"></div>
    </div>
    <TituloSeccion :titulo="this.NombreCompletoProspecto" v-if="!redirigiendoIncode" />
    <ModalObservacion :Observacion="ObservacionArchivo" v-if="!redirigiendoIncode"></ModalObservacion>
    <div class="container contenedor-integracion-expediente" v-if="!redirigiendoIncode">
      <stepper-integracion :pasos="this.pasos" :pasoActual="this.seccionActual"></stepper-integracion>
      <stepper-integracion-movil :pasos="this.pasos"></stepper-integracion-movil>

      <div v-if="this.PerfilTieneAccesoAExpediente(tipoUsuario)">
        <!--LEYENDA PROSPECTOS-->
        <div class="row col-lg-12" style="text-align: left" v-if="this.tipoUsuario == 3">
          <div class="col-lg-12">
            <strong class="titulo-seccion">Bienvenido a la integración de expediente</strong>
            <p class="parrafo-instrucciones mt-2">
              Te encuentras en la etapa más importante del proceso, motivo por el
              cuál deberás proporcionar documentación y datos personales, ten en
              cuenta que toda información está protegida y en cualquier momento
              puedes revisar nuestro
              <u style="cursor: pointer; color: #b8725a" data-bs-toggle="modal"
                data-bs-target="#modalTerminosAvisos">aviso de privacidad.</u>
              <br /><br />
              Completa los pasos, siguiendo las instrucciones:
            </p>
          </div>
        </div>
        <!--LEYENDA COMERCIALES-->
        <div class="row col-lg-12" style="text-align: left" v-else>
          <div class="col-lg-12">
            <p class="parrafo-instrucciones mt-2">
              Recuerda, esta fase es de suma importancia teniendo en cuenta que el
              prospecto nos proporciona sus datos personales e información
              confidencial, por tanto, deberás establecer constante comunicación
              para acompañar y darle certeza durante toda la etapa.
            </p>
          </div>
        </div>


        <!--SOLICITUD INSCRIPCION FIGURAS-->
        <div v-if="EsObligadoSolidarioOCotitular" class="row col-lg-12 seccion-integracion" style="text-align: left">
          <div class="col-lg-8 col-sm-8">
            <span>
              <strong class="titulo-seccion" style="margin-right: 10px">1. Datos personales</strong>
              <span class="ml-2" v-tooltip.right="'Es indispensable revisar y completar tu información, para poder gozar de nuestros beneficios. '
                ">
                <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
              </span>
            </span>
            <p class="parrafo-instrucciones mt-2">
              Ingresa tus datos personales.
            </p>
          </div>
          <div class="col-lg-4 col-sm-4" style="text-align: center">
            <button class="btn boton-primario boton-llenar-solicitud mt-3 w-100"
              @click.prevent="LlenarDatosPersonalesFiguraAdicional()">
              {{
                this.pasos[0].completado == false
                ? "Ingresar datos personales"
                : this.etapaProspecto > 5
                  ? "Consultar Datos Personales"
                  : "Editar datos personales"
              }}
            </button>
            <i class="fas fa-exclamation-triangle iconos-archivo icono-observacion" v-if="observacionSolicitud != null"
              data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(observacionSolicitud.entidadId, 1)"></i>
          </div>
        </div>
        <!--SOLICITUD INSCRIPCION PERSONAS-->
        <div v-else class="row col-lg-12 seccion-integracion" style="text-align: left">
          <div class="col-lg-8 col-sm-8">
            <span>
              <strong class="titulo-seccion" style="margin-right: 10px">1. Solicitud de inscripción</strong>
              <span class="ml-2" v-tooltip.right="'Ayúdanos a completar tu información, esto nos ayudará a continuar con tu proceso'
                ">
                <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
              </span>
            </span>
            <p class="parrafo-instrucciones mt-2">
              Completa la solicitud de inscripción con tus datos personales.
            </p>
          </div>
          <div class="col-lg-4 col-sm-4" style="text-align: center">
            <button class="btn boton-primario boton-llenar-solicitud mt-3 w-100" @click.prevent="LlenarSolicitud()">
              {{
                this.pasos[0].completado == false
                ? "Completar Solicitud Inscripción"
                : this.etapaProspecto > 5
                  ? "Consultar Solicitud Inscripción"
                  : "Editar Solicitud Inscripción"
              }}
            </button>
            <i class="fas fa-exclamation-triangle iconos-archivo icono-observacion" v-if="observacionSolicitud != null"
              data-bs-toggle="modal" data-bs-target="#modalObservacionB"
              @click.prevent="VerObservacion(observacionSolicitud.entidadId, 1)"></i>
          </div>
        </div>
      </div>

      <div class="row col-lg-12">
        <hr class="divisor-seccion" />
      </div>

      <div v-if="this.PerfilTieneAccesoADocumentos(tipoUsuario)">
        <!--SECCIÓN DE DOCUMENTOS-->
        <div class="row col-lg-12 seccion-integracion-b" style="text-align: left">
          <span>
            <strong class="titulo-seccion" style="margin-right: 10px">2. Envío de documentos</strong>
            <span class="ml-2" v-tooltip.right="'Deberás de incorporar tus documentos que son un requisito para seguir el proceso.  '
              ">
              <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
            </span>
          </span>
          <p class="parrafo-instrucciones mt-2">
            Realiza la carga de tus documentos oficiales, los formatos válidos
            son: pdf,png, jpg, office. <br />Tamaño máximo: 40mb por archivo.
          </p>
        </div>
        <div class="row col-lg-12 seccion-integracion-b2" style="text-align: left">
          <strong class="titulo-seccion" style="margin-right: 10px">
            Cargar documento de identificación personal
          </strong>
          <div class="col-lg-4">
            <DropDown placeholder="Tipo de identificación * " :arreglo="this.DocumentosIdentificacion" llave="id"
              valor="id" texto="texto" v-model="DocumentoIdentificacion" :disabled="desactivarInputArchivo"></DropDown>
          </div>
          <input class="d-none" type="file" ref="inputIdentificacion"
            @change="almacenarArchivoIdentificacionEnVariable" />
          <div class="col-lg-6 row-input-documentos">
            <InputDocumentos @click.native="activaInput(DocumentoIdentificacion)"
              ajusteMarginBoton="margin-top: -0.2px !important" :Documento="DocumentoIdentificacion"
              :NombreArchivo="nombreArchivoIdentificacion" :esExtranjero="false" :desactivar="desactivarInputArchivo">
            </InputDocumentos>
          </div>
          <div class="col-lg-2 contenedor-iconos-integracion">
            <i v-if="DocumentoIdentificacionId != null" class="fa fa-download iconoArchivo-png"
              v-on:click="descargarArchivoIdentificacion"></i>
            <i v-if="DocumentoIdentificacionId != null && !desactivarInputArchivo
              " v-on:click="eliminarArchivoIdentificacion" class="fa fa-trash iconoBorrar-png"></i>
            <i class="
                fas
                fa-exclamation-triangle
                iconos-archivo
                icono-observacion
              " v-if="this.DocumentoIdentificacionAprobado == false" data-bs-toggle="modal"
              data-bs-target="#modalObservacionB" @click.prevent="VerObservacion(DocumentoIdentificacionId, 0)"></i>
          </div>
        </div>
        <div>
          <div style="text-align: left" class="row col-lg-12 seccion-integracion-c2"
            v-for="(comprobante, index) in comprobantesIngresoCargados"
            :key="comprobantesIngresoCargados.indexOf(comprobante)">
            <div v-if="index == 0">
              <span>
                <strong class="titulo-seccion" style="margin-right: 10px">
                  Cargar comprobantes de ingresos.
                </strong>
                <span class="ml-2" v-tooltip.right="'Carga tus documentos de acuerdo a las indicaciones que se muestran.'
                  ">
                  <i class="fas fa-question-circle icono-ayuda fa-lg"></i>
                </span>
              </span>
              <br />
              <label class="parrafo-instrucciones mt-2">Puedes comprobar ingresos con:</label>
              <ul class="parrafo-instrucciones mt-1">
                <li>6 meses de estados de cuenta y/o</li>
                <li>3 meses de recibos de nómina timbrados y/o,</li>
                <li>3 meses de declaraciones parciales y/o,</li>
                <li>
                  Arrendamientos a través de contratos de arrendamiento y
                  escrituras de la propiedad o predial.
                </li>
                <li>Estudio socioeconómico.</li>
              </ul>
            </div>
            <input class="d-none" type="file" ref="inputComprobante"
              @change="almacenarArchivoComprobanteEnVariable($event, index)" />
            <div class="col-lg-4">
              <DropDown placeholder="Tipo de comprobante * " :arreglo="DocumentosComprobantesIngresos" llave="id"
                valor="id" texto="texto" v-model="comprobante.documento"
                @change.native="actualizarTipoComprobanteIngreso($event, index)" ref="dropdownTipoComprobante"
                :disabled="desactivarInputArchivo"></DropDown>
            </div>
            <div class="col-lg-6 row-input-documentos">
              <InputDocumentos @click.native="
                activaInputComprobante(index, comprobante.documento)
                " ajusteMarginBoton="margin-top: 0px" :Documento="comprobante.documento"
                :NombreArchivo="comprobante.nombreOriginal" :esExtranjero="false" :desactivar="desactivarInputArchivo">
              </InputDocumentos>
            </div>
            <div class="col-lg-2 contenedor-iconos-integracion">
              <i v-if="comprobante.archivoId != null" class="fa fa-download iconoArchivo-png"
                v-on:click="descargarArchivo(comprobante.archivoId)"></i>
              <i v-if="comprobante.archivoId != null && !desactivarInputArchivo" class="fa fa-trash iconoBorrar-png"
                v-on:click="eliminarComprobanteCargado(comprobante)"></i>
              <i class="
                  fas
                  fa-exclamation-triangle
                  iconos-archivo
                  icono-observacion
                " v-if="comprobante.esAprobado == false" data-bs-toggle="modal" data-bs-target="#modalObservacionB"
                @click.prevent="VerObservacion(comprobante.archivoId, 0)"></i>
            </div>
          </div>
        </div>
        <div class="row col-lg-12 seccion-integracion-c3" style="display: flex; justify-content: flex-end" v-if="comprobantesIngresoCargados[comprobantesIngresoCargados.length - 1]
        .archivoId != null && !desactivarInputArchivo
        ">
        <strong style="width: auto" class="etiqueta-nuevo-documento"
          @click.prevent="MostrarInputsNuevoComprobante()">Agregar otro comprobante</strong>
        </div>
        <div class="row col-lg-12" v-if="this.PerfilTieneAccesoABuro(tipoUsuario) && tipoUsuario == 3">
          <hr class="divisor-seccion" />
        </div>
        <!--  Autorización de la consulta de información de buró de crédtio mediante Firma Simple-->
        <div v-if="this.PerfilTieneAccesoABuro(tipoUsuario) && tipoUsuario == 3">
          <div  v-if="(EsObligadoSolidarioNacional && DocumentoBuroCreditoId == null) || EsTitularOCotitular" class="row col-lg-12 mt-3 seccion-integracion-d" style="text-align: left">
            <div class="row">
              <strong class="titulo-seccion">3. Autorización de consulta de buró de crédito</strong>
            </div>
            <div class="col-lg-8">
              <p class="parrafo-instrucciones mt-2">
                Autoriza la consulta de tu buró completando los datos del
                formulario, toma en cuenta que deberás realizar el proceso en un
                dispositivo móvil.
              </p>
            </div>
            <div class="col-lg-4" style="text-align: center;" v-if="procesandoDatosBuro">
              <v-progress-circular model-value="20" indeterminate></v-progress-circular>
            </div>
            <div v-else class="col-lg-4" style="text-align: center">
              <button v-if="this.pasos[0].completado == true &&
                this.pasos[1].completado == true &&
                infoBuroConsultada == false
                " class="btn boton-primario boton-llenar-solicitud mt-3 w-100" @click.prevent="AutorizarBuro()">
                Autorizar
              </button>
              <button v-else-if="!infoBuroConsultada" class="btn boton-primario boton-llenar-solicitud mt-3 w-100"
                disabled>
                Autorizar
              </button>
              <span v-if="infoBuroConsultada">
                <i class="fas fa-lock ml-2" style="color: #00917c; font-size: 20px"></i>
                <label style="
                  font-family: 'Poppins';
                  color: #00917c;
                  margin-left: 15px;
                ">
                  Autorizado</label>
              </span>
            </div>
          </div>
        </div>
        <div v-if="this.PerfilTieneAccesoABuro(tipoUsuario)" class="col-lg-12" style="text-align: start;">
          <p>O si lo deseas puedes subir tu Buró de Crédito manualmente.</p>
        </div>
        <!--Carga manual de documento con información de buró de crédito-->
        <div v-if="this.PerfilTieneAccesoABuro(tipoUsuario)" style="margin-top: -30px;">
          <div class="row col-lg-12 seccion-integracion-d" style="text-align: left">
            <div class="row" v-if="PuedeSubirArchivoBuro">
              <!--BURO CARGA DE ARCHIVO-->
              <div class="row col-lg-12 seccion-integracion-b2" style="text-align: left;">
                <div class="col-lg-4">
                  <DropDown placeholder="Tipo de documento " :arreglo="this.DocumentosBuroCredito" llave="id"
                    valor="id" texto="texto" v-model="DocumentoBuroCredito" :disabled="desactivarInputArchivo"></DropDown>
                </div>
                <input class="d-none" type="file" ref="inputBuro" @change="almacenarArchivoBuro"
                  style="background-color: gray" />
                <div class="col-lg-6 row-input-documentos">
                  <InputDocumentos @click.native="activaInputBuro(DocumentoBuroCredito)"
                    ajusteMarginBoton="margin-top: -0.2px !important" :Documento="DocumentoBuroCredito"
                    :NombreArchivo="nombreDocumentoBuro" :esExtranjero="false" :desactivar="desactivarInputArchivo">
                  </InputDocumentos>
                </div>
                <div class="col-lg-2 contenedor-iconos-integracion">
                  <i v-if="DocumentoBuroCreditoId != null" v-on:click="descargarDocumentoBuroCredito"
                    class="fa fa-download iconoArchivo-png"></i>
                  <i v-if="DocumentoBuroCreditoId != null && !desactivarInputArchivo" v-on:click="eliminarArchivoBuroCredito"
                    class="fa fa-trash iconoBorrar-png"></i>
                  <i class="
                      fas
                      fa-exclamation-triangle
                      iconos-archivo
                      icono-observacion
                    " v-if="this.DocumentoBuroCreditoAprobado == false" data-bs-toggle="modal"
                    data-bs-target="#modalObservacionB" @click.prevent="VerObservacion(DocumentoBuroCreditoId, 0)"></i>
                </div>
              </div>
            </div>
        </div>
        </div>
        <div class="row col-lg-12 mt-5">
          <hr class="divisor-seccion" />
        </div>
      </div>
      <div class="row col-lg-12" v-if="this.PerfilTieneAccesoAExpediente(tipoUsuario)">
        <div class="col-lg-8"></div>
        <div
          v-if="tipoUsuario == 3 || tipoUsuario == 4 || tipoUsuario == 5 || tipoUsuario == 6 || tipoUsuario == 8 || tipoUsuario == 10"
          class="col-lg-4">
          <button disabled class="
              btn
              boton-primario boton-llenar-solicitud boton-finalizar-integracion
              w-100
            " v-if="integrandoExpediente">
            <v-progress-circular indeterminate size="30" color="primary"></v-progress-circular>
          </button>
          <button v-else class="
              btn
              boton-primario boton-llenar-solicitud boton-finalizar-integracion
              w-100
            " :disabled="desactivarInputArchivo" v-on:click="terminarIntegracionExpediente">
            Finalizar
          </button>
        </div>
      </div>
    </div>
    <!-- Componente de qr -->
    <QrCodeDialog :modalActivo="modalVisibleQr" @modalClosed="updateModalState"></QrCodeDialog>
  </div>
</template>

<script>
//Plugins
import servicios from "../../../servicios/service.js";
import axios from "axios";
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
import { ObtenerAutorizacionBuroApi, getSession, obtenerDatosProspectoBuroCredito, enviarDatosProspectoBuroCredito } from "@/Aplicaciones/Masters/apiConnection/api_client";
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import ModalObservacion from "../components/ModalObservacion.vue";
import DropDown from "../components/DropDown.vue";
import InputDocumentos from "../components/InputDocumentos.vue";
import StepperIntegracion from "../components/StepperIntegracion.vue";
import StepperIntegracionMovil from "../components/StepperIntegracionMovil.vue";
import QrCodeDialog from "@/Aplicaciones/Masters/Areas/Prospecto/components/QrCodeDilaog.vue"


const rutaListarDocumentosIdentificacion =
  "/api/Master/IntegracionExpediente/ListarDocumentosIdentificacion";
const rutaListarDocumentosBuroCredito =
  "/api/Master/IntegracionExpediente/ListarDocumentosBuroCredito";
const rutaCargarDatosIdentificacionProspecto =
  "/api/Master/IntegracionExpediente/CargarDatosArchivoIdentificacionProspecto";
const rutaCargarDatosBuroCredito =
  "/api/Master/IntegracionExpediente/CargarDatosArchivoBuroCredito";
const rutaGuardarArchivoIdentificacionProspecto =
  "/api/Master/IntegracionExpediente/GuardarArchivoIdentificacionProspecto";
const rutaGuardarArchivoBuroCredito =
  "/api/Master/IntegracionExpediente/GuardarArchivoBuroCredito";
const rutaDescargarArchivoIdentificacionProspecto =
  "/api/Master/IntegracionExpediente/DescargarArchivoIdentificacionProspecto";
const rutaEliminarArchivoIdentificacionProspecto =
  "/api/Master/IntegracionExpediente/EliminarDocumentoIdentificacionProspecto";

const rutaDescargarArchivoBuroCredito =
  "/api/Master/IntegracionExpediente/DescargarArchivoBuroCredito";

const rutaListarDocumentosIngresos =
  "/api/Master/IntegracionExpediente/ListarDocumentosComprobantesDeIngresos";

const rutaCrearArchivoComprobanteIngresoProspecto =
  "/api/Master/IntegracionExpediente/CrearArchivoComprobanteIngresoProspecto";
const rutaCargarComprobantesIngresoProspecto =
  "/api/Master/IntegracionExpediente/CargarDatosComprobantesIngresoProspecto";
const rutaCargarArchivoBuroCredito =
  "/api/Master/IntegracionExpediente/ObtenerDatosArchivoBuroCredito";

const rutaTerminarIntegracionExpediente =
  "/api/Master/IntegracionExpediente/TerminarIntegracionExpediente";

const rutaDescargarArchivo = "/api/Master/Archivo/DescargarArchivo";
const rutaEliminarArchivo = "/api/Master/Archivo/EliminarArchivo";
const rutaActualizarArchivo = "/api/Master/Archivo/ActualizarArchivo";
const rutaActualizarDatosArchivo = "/api/Master/Archivo/ActualizarDatosArchivo";
const rutaProspectoExpedienteCompleto =
  "/api/Master/IntegracionExpediente/ProspectoTieneCompletoExpediente";
const rutaProspectoSolicitudCompleta =
  "/api/Master/IntegracionExpediente/ProspectoTieneCompletaSolicitud";
const rutaConsultarObservacionArchivo =
  "/api/Master/PreAutorizacion/ConsultarObservacionArchivo";
const rutaEliminarArchivoBuroCredito =
  "/api/Master/IntegracionExpediente/EliminarArchivoBuroCredito";

export default {
  name: "IntegracionExpediente",
  mixins: [mixinSolicitudInscripcion],
  async mounted() {
    servicios.OnboardingOnProgress(false);
    this.respuestaIncode = this.$route.params["respuestaIncode"];
    if (this.respuestaIncode == true) {
      this.$fire({
        title: "Autorización de buró aprobada",
        html:
          "<br>La autenticación de tu identidad ha sido exitosa.<br>" +
          "Selecciona el botón finalizar para concluir el proceso de la integración de expediente.<br>",
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: "Aceptar",
      });
    }

    this.redirigiendoIncode = false;
    document.getElementsByClassName(
      "principal-menu-navegacion"
    )[0].style.display = "block";
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    if (
      this.tipoUsuario == 1 &&
      !window.sessionStorage.getItem("avisoPrivacidadEmbajadorMostrado")
    ) {
      this.$fire({
        title: "Aviso de privacidad",
        text:
          "Tu perfil de Embajador está limitado en la visualización de documentos por la protección de datos mencionada en nuestro aviso de privacidad.",
        confirmButtonText: "Aceptar",
        showCancelButton: false,
      });
      window.sessionStorage.setItem("avisoPrivacidadEmbajadorMostrado", true);
    }
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = await this.ObtenerTipoPersona(this.ProspectoId);
    let datos = (await this.ObtenerDatosProspecto(this.ProspectoId)).data.data;
    this.NombreCompletoProspecto = "INTEGRACIÓN DE EXPEDIENTE: " + datos.nombres + " " + datos.apellidoPaterno + " " + datos.apellidoMaterno;

    this.etapaProspecto = datos.etapaId;
    await this.ProspectoTieneCompletoExpediente();
    await this.ProspectoTieneCompletaSolicitud();
    await this.ConsultarSolicitudes(this.ProspectoId, false);
    await this.SolicitudTieneObservacion(this.ProspectoId, 1);

    if (servicios.PerfilTieneAccesoADocumentos(this.tipoUsuario)) {
      this.listarDocumentosIdentificacion();
      this.listarDocumentosComprobantesDeIngresos();
      if (servicios.PerfilTieneAccesoADocumentos(this.tipoUsuario) || (this.tipoPersona == 6 || this.tipoPersona == 7)) {
        this.listarDocumentosBuroCredito();
        await this.cargarArchivoBuroCredito();
      }
      this.cargarComprobantesIngresoProspecto();
      this.cargarArchivoIdentificacionProspecto();
    }

    await this.ObtenerSesionIncode();
    await this.consultarAutorizacionBuro(this.ProspectoId);

    if ((this.tipoUsuario == 3 && this.etapaProspecto > 4) ||
      ((this.tipoUsuario == 5 ||
        this.tipoUsuario == 6 ||
        this.tipoUsuario == 8 ||
        this.tipoUsuario == 9 ||
        this.tipoUsuario == 10) &&
        this.etapaProspecto > 4)
    ) {
      this.desactivarInputArchivo = true;
      this.pasos[2].completado = true;
      this.desactivaDescargarArchivo = true;
    }
    if(this.etapaProspecto === 9)
      this.desactivarInputArchivo = false;
    
    const preonboarding = sessionStorage.getItem('preonboarding') == 'true' ? true : false 
    if(preonboarding){
     await this.AutorizarBuro()
    }
  },
  components: {
    ModalObservacion,
    TituloSeccion,
    DropDown,
    InputDocumentos,
    StepperIntegracion,
    StepperIntegracionMovil,
    QrCodeDialog
  },
  data() {
    return {
      isMobile: /Mobi/i.test(navigator.userAgent),
      loadingArchivo: false,
      respuestaIncode: false,
      integrandoExpediente: false,
      pasos: [
        {
          nombre: this.EsObligadoSolidarioOCotitular
            ? "Datos personales"
            : "Solicitud de inscripción",
          completado: false,
        },
        {
          nombre: "Envío de documentos",
          completado: false,
        },
        {
          nombre: "Autorización de buró",
          completado: false,
        },
      ],
      seccionActual: 0,
      nombreArchivoIdentificacion: null,
      nombreDocumentoBuro: null,
      NombreCompletoProspecto: "",
      tipoUsuario: null,
      tipoPersona: null,
      SolicitudId: 0,
      DocumentosIdentificacion: [],
      DocumentosComprobantesIngresos: [],
      DocumentosBuroCredito: [],
      DocumentoIdentificacion: null,
      DocumentoBuroCredito: null,
      DocumentoIdentificacionId: null,
      DocumentoBuroCreditoId: null,
      DocumentoComprobanteIngreso: null,
      ProspectoId: null,
      ArchivoIdentificacion: null,
      ArchivoComprobanteIngreso: null,
      ArchivoNuevoComprobanteIngreso: null,
      NombreNuevoArchivoComprobante: null,
      ArchivosComprobantesIngresos: [],
      ArchivoBuroCredito: null,
      ObservacionArchivo: null,
      observacionSolicitud: null,
      DocumentoIdentificacionAprobado: null,
      DocumentoBuroCreditoAprobado: null,

      comprobantesIngresoCargados: [
        {
          archivoId: null,
          nombreOriginal: "",
          documento: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      documentosBuroCreditoCargados: [
        {
          archivoId: null,
          nombreOriginal: "",
          documento: null,
          esAprobado: true,
          archivo: null,
        },
      ],
      // Comentarios Random
      //Para enviar a la API FIRMA SIMPLE
      DatosPersonales: {
        pinId: null,
        nombre: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        sexo: null,
        fechaNacimiento: null,
        rfc: null,
        telefonoCelular: null,
        telefonoFijo: null,
        correoElectronico: null,
        calle: null,
        numeroInterior: null,
        numeroExterior: null,
        colonia: null,
        estado: null,
        municipio: null,
        codigoPostal: null,
        AutorizaConsultaHistorialCrediticio: true,
        AutorizaUtilizacionMedios: true,
        AceptaTerminosCondiciones: true,
        //Agregado
        DatosPersonalesBuro: null,
        SesionExistente: null,
      },
      redirigiendoIncode: false,
      etapaProspecto: null,
      desactivarInputArchivo: false,
      desactivaDescargarArchivo: false,
      /* Refactor properties */
      procesandoDatosBuro: false,
      modalVisibleQr: false,
      /*  Finalizar intracion requeridos.  */
      tieneArchivoBuro: false,
      onboardingIncodeCompleto: false,
      infoBuroConsultada: false
    };
  },
  computed: {
    TieneInformacionBuro() {
      const tieneInformacionBuro = this.DocumentoBuroCreditoId != null || this.infoBuroConsultada;
      return tieneInformacionBuro;
    },
    PuedeSubirArchivoBuro() {
      return (this.tipoPersona == 6 || this.tipoPersona == 0 || this.tipoPersona == 4);
    },
    EsObligadoSolidarioNacional(){
      return this.tipoPersona == 6 ? true : false;
    },
    EsTitularOCotitular() {
      return (this.tipoPersona == 4 || this.tipoPersona == 0) ? true : false;
    },
    EsObligadoSolidarioOCotitular() {
      var tipo = this.tipoPersona;
      if (tipo == 4 || tipo == 5 || tipo == 6 || tipo == 7) return true;
      return false;
    },
    PasosStepper() {
      return [
        {
          nombre: this.EsObligadoSolidarioOCotitular
            ? "Datos personales"
            : "Solicitud de inscripción",
          completado: false,
        },
        {
          nombre: "Envío de documentos",
          completado: false,
        },
        {
          nombre: "Autorización de buró",
          completado: false,
        },
      ];
    },
  },
  methods: {
    async consultarAutorizacionBuro(prospectoId) {
      const { data } = await ObtenerAutorizacionBuroApi(prospectoId);
      this.infoBuroConsultada = data;
    },
    async ObtenerSesionIncode() {
      const session = await getSession(this.ProspectoId);
      if (session != null) {
        if (session.finishStatus == 'COMPLETE') {
          this.onboardingIncodeCompleto = true;
        } else this.onboardingIncodeCompleto = false;
      } else {
        this.onboardingIncodeCompleto = false;
      }
    },
    async procesarDatosBuroCredito() {
      try {
        this.procesandoDatosBuro = true;
        const { data } = await obtenerDatosProspectoBuroCredito(this.ProspectoId);
        if (data) {
          await enviarDatosProspectoBuroCredito(data);
          this.procesandoDatosBuro = false
        } else {
          this.procesandoDatosBuro = false
          this.AlertaEmbajadores('No logramos encontrar tus datos personales, por favor intentalo nuevamente.', true);
        }
      } catch (e) {
        console.log(e);
        this.procesandoDatosBuro = false
        this.AlertaEmbajadores('No logramos procesar tus datos de buró de crédito, por favor intentalo nuevamente.', true);
      }
    },
    async AutorizarBuro() {
      this.$store.commit('setGoToSinOnboarding', {to:'IntegracionExpediente'})
      if (this.onboardingIncodeCompleto) {
        await this.procesarDatosBuroCredito();
        await this.consultarAutorizacionBuro(this.ProspectoId);
      } else if (this.isMobile) {
        this.$router.push({ name: "WelcomeOnBoarding" });
      } else {
        this.$router.push({ name: "InformacionAutenticacionIdentidad" });
      }
    },
    async realizarAutenticacionIdentidad(){
      if(this.isMobile) {
        this.$router.push({ name: "WelcomeOnBoarding" });
      } else {
        this.$router.push({ name: "InformacionAutenticacionIdentidad" });
      }
    },
    /* Refactor methods ends */
    PerfilTieneAccesoAExpediente(usuario) {
      return servicios.PerfilTieneAccesoAExpediente(usuario);
    },
    PerfilTieneAccesoADocumentos(usuario) {
      return servicios.PerfilTieneAccesoADocumentos(usuario);
    },
    PerfilTieneAccesoABuro(usuario) {
      return servicios.PerfilTieneAccesoABuro(usuario);
    },
    //Agregado
    MostrarInputsNuevoComprobante() {
      this.comprobantesIngresoCargados.push({
        archivoId: null,
        nombreOriginal: "",
        documento: null,
        esAprobado: true,
        archivo: null,
      });
    },
    activaInput(documento) {
      if (documento != null) console.log(this.etapaProspecto);
      if (this.etapaProspecto < 5) this.$refs["inputIdentificacion"].click();
    },
    activaInputComprobante(index, documento) {
      if (documento != null) console.log(this.etapaProspecto);
      if (this.etapaProspecto < 5) this.$refs.inputComprobante[index].click();
    },
    activaInputNuevoComprobante() {
      this.$refs["inputNuevoComprobante"].click();
    },
    activaInputBuro(documento) {
      if (documento != null)
        if (this.etapaProspecto < 5) this.$refs["inputBuro"].click();
    },
    ProspectoTieneCompletaSolicitud() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId
        }
      };
      axios
        .get(rutaProspectoSolicitudCompleta, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.pasos[0].completado = resp.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ProspectoTieneCompletoExpediente() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId
        }
      };
      axios
        .get(rutaProspectoExpedienteCompleto, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.pasos[1].completado = resp.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    VerObservacion(archivoId, tipoEntidad) {
      const archivo = {
        params: {
          entidadId: archivoId,
          tipoEntidad: tipoEntidad
        },
      };
      axios
        .get(rutaConsultarObservacionArchivo, archivo)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.ObservacionArchivo = resp.data.data.resultado;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    LlenarDatosPersonalesFiguraAdicional() {
      if (this.etapaProspecto == 5) {
        if (this.tipoUsuario != 1) {
          switch (this.tipoPersona) {
            case 4:
            case 6:
              this.$router.push({ name: "DatosPersonalesFiguraAdicional" });
              break;
            case 5:
            case 7:
              this.$router.push({ name: "DatosPersonalesFiguraAdicionalex" });
              break;
          }
        }
      } else {
        switch (this.tipoPersona) {
          case 4:
          case 6:
            this.$router.push({ name: "DatosPersonalesFiguraAdicional" });
            break;
          case 5:
          case 7:
            this.$router.push({ name: "DatosPersonalesFiguraAdicionalex" });
            break;
        }
      }
    },
    LlenarSolicitud() {
      this.$store.commit("setSolicitudFisica", this.SolicitudId);
      if (this.$route.params.vieneDeAdministracion == undefined)
        this.$router.push("FormularioSolicitudInscripcion");
      else
        this.$router.push({
          name: "FormularioSolicitudInscripcion",
          params: { vieneDeAdministracion: true },
        });
    },
    listarDocumentosIdentificacion() {
      axios
        .get(rutaListarDocumentosIdentificacion)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.DocumentosIdentificacion = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    listarDocumentosBuroCredito() {
      axios
        .get(rutaListarDocumentosBuroCredito)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.DocumentosBuroCredito = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    cargarArchivoIdentificacionProspecto() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaCargarDatosIdentificacionProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data.length > 0) {
              this.DocumentoIdentificacion = resp.data.data[0].documento;
              this.DocumentoIdentificacionAprobado =
                resp.data.data[0].esAprobado;
              this.DocumentoIdentificacionId = resp.data.data[0].archivoId;
              this.nombreArchivoIdentificacion =
                resp.data.data[0].nombreOriginal;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async cargarArchivoBuroCredito() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      await axios
        .get(rutaCargarDatosBuroCredito, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            if (resp.data.data.length > 0) {
              this.DocumentosBuroCredito.valor = resp.data.data[0].documento;
              this.DocumentoBuroCreditoAprobado = resp.data.data[0].esAprobado;
              this.DocumentoBuroCreditoId = resp.data.data[0].archivoId;
              this.nombreDocumentoBuro = resp.data.data[0].nombreOriginal;
              this.DocumentoBuroCredito = 20;
              this.pasos[2].completado = true;
            } else {
              this.DocumentosBuroCredito.valor = null;
              this.DocumentoBuroCreditoAprobado = null;
              this.DocumentoBuroCreditoId = null;
              this.nombreDocumentoBuro = null;
              this.DocumentoBuroCredito = null;
              this.pasos[2].completado = false;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async eliminarArchivoBuroCredito() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId,
        },
      };
      await axios.get(rutaEliminarArchivoBuroCredito, prospecto);
      await this.cargarArchivoBuroCredito();
    },
    subirArchivoIdentificacion() {
      if (this.ProspectoId != null) {
        if (this.ArchivoIdentificacion === null) {
          this.$fire({
            title: "Carga de archivo",
            html: "<br>Debe cargar un archivo<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (this.DocumentoIdentificacion === null) {
          this.$fire({
            title: "Tipo de identificación",
            html: "<br>Debe seleccionar un tipo de identificación<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarFormatoArchivoValido(this.ArchivoIdentificacion)
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(this.ArchivoIdentificacion)
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.ArchivoIdentificacion);
        paqueteDeDatos.append("documento", this.DocumentoIdentificacion);
        axios
          .post(rutaGuardarArchivoIdentificacionProspecto, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarArchivoIdentificacionProspecto();
              this.ProspectoTieneCompletoExpediente();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    subirArchivoBuro() {
      if (this.ProspectoId != null) {
        if (this.ArchivoBuroCredito === null) {
          this.$fire({
            title: "Carga de archivo",
            html: "<br>Debe cargar un archivo<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (this.DocumentoBuroCredito === null) {
          this.$fire({
            title: "Tipo de identificación",
            html: "<br>Debe seleccionar un tipo de identificación<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (!servicios.validarFormatoArchivoValido(this.ArchivoBuroCredito)) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (!servicios.validarTamanioArchivoValido(this.ArchivoBuroCredito)) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("archivo", this.ArchivoBuroCredito);
        paqueteDeDatos.append("documento", 20);
        axios
          .post(rutaGuardarArchivoBuroCredito, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarArchivoBuroCredito();
              this.ProspectoTieneCompletoExpediente();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    subirArchivoComprobante(index) {
      if (this.ProspectoId != null) {
        if (this.comprobantesIngresoCargados[index].archivoId != null) {
          if (this.comprobantesIngresoCargados[index].archivo === null) {
            this.$fire({
              title: "Carga de archivo",
              html: "<br>Debe cargar un archivo<br><br>",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Aceptar",
            });
            return;
          }
        }

        if (this.comprobantesIngresoCargados[index].documento === null) {
          this.$fire({
            title: "Tipo de comprobante",
            html: "<br>Debe seleccionar un tipo de comprobante.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarFormatoArchivoValido(
            this.comprobantesIngresoCargados[index].archivo
          )
        ) {
          this.$fire({
            title: "Formato de archivo inválido",
            html:
              "<br>El archivo que cargaste no cuenta con las características:<br>" +
              "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          !servicios.validarTamanioArchivoValido(
            this.comprobantesIngresoCargados[index].archivo
          )
        ) {
          this.$fire({
            title: "Peso máximo",
            html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        if (this.comprobantesIngresoCargados[index].archivoId != null) {
          paqueteDeDatos.append(
            "archivoId",
            this.comprobantesIngresoCargados[index].archivoId
          );
        }
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append(
          "archivo",
          this.comprobantesIngresoCargados[index].archivo
        );
        paqueteDeDatos.append(
          "documento",
          this.comprobantesIngresoCargados[index].documento
        );
        axios
          .post(rutaCrearArchivoComprobanteIngresoProspecto, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.cargarComprobantesIngresoProspecto();
              this.ProspectoTieneCompletoExpediente();
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    almacenarArchivoIdentificacionEnVariable(event) {
      this.loadingArchivo = true;
      this.ArchivoIdentificacion = event.target.files[0];
      event.target.value = "";
      this.subirArchivoIdentificacion();
    },
    almacenarArchivoComprobanteEnVariable(event, index) {
      this.comprobantesIngresoCargados[index].archivo = event.target.files[0];
      event.target.value = "";
      this.subirArchivoComprobante(index);
    },
    almacenarArchivoBuro(event) {
      this.ArchivoBuroCredito = event.target.files[0];
      event.target.value = "";
      this.subirArchivoBuro();
    },
    descargarArchivoIdentificacion() {
      if (this.ProspectoId != null) {
        window.location.href =
          rutaDescargarArchivoIdentificacionProspecto +
          "?prospectoId=" +
          this.ProspectoId;
      }
    },
    descargarDocumentoBuroCredito() {
      if (this.ProspectoId != null) {
        window.location.href =
          rutaDescargarArchivoBuroCredito + "?prospectoId=" + this.ProspectoId;
      }
    },
    eliminarArchivoIdentificacion() {
      this.$fire({
        title: "Eliminar archivo",
        html:
          "<br>Estás por eliminar este archivo<br>" + "¿Deseas continuar?<br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: true,
      }).then((result) => {
        if (result.value) {
          if (this.ProspectoId != null) {
            var paqueteDeDatos = new FormData();
            paqueteDeDatos.append("prospectoId", this.ProspectoId);
            axios
              .post(rutaEliminarArchivoIdentificacionProspecto, paqueteDeDatos)
              .then((resp) => {
                if (resp.data.estado === 0) {
                  this.DocumentoIdentificacion = null;
                  this.DocumentoIdentificacionAprobado = null;
                  this.DocumentoIdentificacionId = null;
                  this.$refs.inputIdentificacion.value = null;
                  this.nombreArchivoIdentificacion = null;
                  this.ProspectoTieneCompletoExpediente();
                  this.$forceUpdate();
                  this.AlertaEmbajadores(resp.data.mensaje, true);
                } else if (resp.data.estado === 1) {
                  this.AlertaEmbajadores(resp.data.mensaje, true);
                }
              })
              .catch((e) => {
                this.ManejarExcepcion(e);
              });
          }
        }
      });
    },
    listarDocumentosComprobantesDeIngresos() {
      axios
        .get(rutaListarDocumentosIngresos)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.DocumentosComprobantesIngresos = resp.data.data;
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    rutaCargarArchivoBuroCredito() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaCargarArchivoBuroCredito, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloComprobantes = resp.data.data;
            if (arregloComprobantes.length > 0) {
              this.documentosBuroCreditoCargados = [];
              for (var item of arregloComprobantes) {
                let comprobante = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.documentosBuroCreditoCargados.push(comprobante);
              }
              this.$forceUpdate();
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    cargarComprobantesIngresoProspecto() {
      const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaCargarComprobantesIngresoProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            let arregloComprobantes = resp.data.data;
            if (arregloComprobantes.length > 0) {
              this.comprobantesIngresoCargados = [];
              for (var item of arregloComprobantes) {
                let comprobante = {
                  archivoId: item.archivoId,
                  nombreOriginal: item.nombreOriginal,
                  documento: item.documento,
                  esAprobado: item.esAprobado,
                };
                this.comprobantesIngresoCargados.push(comprobante);
              }
              this.$forceUpdate();
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    eliminarComprobanteCargado(comprobante) {
      this.eliminarArchivo(comprobante);
    },
    descargarArchivo(archivoId) {
      window.location.href = rutaDescargarArchivo + "?archivoId=" + archivoId;
    },
    eliminarArchivo(comprobante) {
      this.$fire({
        title: "Eliminar archivo",
        html:
          "<br>Estás por eliminar este archivo<br>" + "¿Deseas continuar?<br>",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        allowOutsideClick: true,
      }).then((result) => {
        if (result.value) {
          var paqueteDeDatos = new FormData();
          paqueteDeDatos.append("archivoId", comprobante.archivoId);
          return axios
            .post(rutaEliminarArchivo, paqueteDeDatos)
            .then((resp) => {
              if (resp.data.estado === 0) {
                this.cargarComprobantesIngresoProspecto();
                this.ProspectoTieneCompletoExpediente();
                this.AlertaEmbajadores(resp.data.mensaje, true);
              } else if (resp.data.estado === 1) {
                this.AlertaEmbajadores(resp.data.mensaje, true);
              }
              if (this.comprobantesIngresoCargados.length == 1) {
                this.comprobantesIngresoCargados = [
                  {
                    archivoId: null,
                    nombreOriginal: "",
                    documento: null,
                    esAprobado: true,
                    archivo: null,
                  },
                ];
              } else {
                let i = this.comprobantesIngresoCargados.indexOf(comprobante);
                if (i != -1) {
                  this.comprobantesIngresoCargados.splice(i, 1);
                }
              }
            })
            .catch((e) => {
              this.ManejarExcepcion(e);
            });
        }
      });
    },
    actualizarArchivo(event, archivoId) {
      if (event.target.files[0] === null) {
        this.$fire({
          title: "Carga de archivo",
          html: "<br>Debe cargar un archivo<br><br>",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return;
      }

      if (!servicios.validarFormatoArchivoValido(event.target.files[0])) {
        this.$fire({
          title: "Formato de archivo inválido",
          html:
            "<br>El archivo que cargaste no cuenta con las características:<br>" +
            "Formato válido: pdf, png, jpg, office. Tamaño máximo: 40mb por archivo.<br><br>",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return;
      }

      if (!servicios.validarTamanioArchivoValido(event.target.files[0])) {
        this.$fire({
          title: "Peso máximo",
          html: "<br>El archivo sobrepasa el tamaño permitido<br><br>",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return;
      }

      var paqueteDeDatos = new FormData();
      paqueteDeDatos.append("archivoId", archivoId);
      paqueteDeDatos.append("archivo", event.target.files[0]);

      axios
        .post(rutaActualizarArchivo, paqueteDeDatos)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    actualizarTipoComprobanteIngreso(event, index) {
      if (this.comprobantesIngresoCargados[index].archivoId != null) {
        if (event.target.value === null) {
          this.$fire({
            title: "Tipo de comprobante",
            html: "<br>Debe seleccionar un tipo de comprobante.<br><br>",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return;
        }

        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append(
          "archivoId",
          this.comprobantesIngresoCargados[index].archivoId
        );
        paqueteDeDatos.append("documento", event.target.value);

        axios
          .post(rutaActualizarDatosArchivo, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
          });
      }
    },
    async terminarIntegracionExpediente() {
      const tieneInformacionBuro  = this.TieneInformacionBuro;
      if (this.ProspectoId != null) {
        this.integrandoExpediente = true;
        var paqueteDeDatos = new FormData();
        paqueteDeDatos.append("prospectoId", this.ProspectoId);
        paqueteDeDatos.append("AplicacionId", 0);
        if(!tieneInformacionBuro) {
          this.AlertaEmbajadores(
            "Por favor, suba su información de buró de crédito o realice la consulta.",
            true
          );
          this.integrandoExpediente = false;
          return;
        }
        axios
          .post(rutaTerminarIntegracionExpediente, paqueteDeDatos)
          .then((resp) => {
            if (resp.data.estado === 0) {
              if (this.tipoUsuario == 3) {
                this.$fire({
                  title:
                    "¡Has concluido exitosamente la integración de tu expediente!",
                  text:
                    "En los próximos días te estaremos notificando su estatus de autorización. Seguimos a tu lado para cumplir tu sueño inmobiliario.",
                  confirmButtonText: "Aceptar",
                });
                this.integrandoExpediente = false;
                this.$router.push({
                  name: "SeguimientoProspecto",
                });
              } else {
                this.AlertaEmbajadores(
                  "El expediente ha sido enviado a preautorización.",
                  true
                );
                this.integrandoExpediente = false;
                this.$router.push({
                  name: "AdministracionDeProspectos"
                });
              }
            } else if (resp.data.estado === 1) {
              this.integrandoExpediente = false;
              this.AlertaEmbajadores(resp.data.mensaje, true);
            }
          })
          .catch((e) => {
            this.integrandoExpediente = false;
            this.ManejarExcepcion(e);
          });
      }
    },
    EsDispositivoMovil() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? true
        : false;
    },
    toggleModalQr() {
      this.modalVisibleQr = true
    },
    updateModalState() {
      this.modalVisibleQr = false; // Actualiza la variable cuando se emite el evento
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

$cafe-embajadores: #696158;

.integracion-expediente-principal {
  width: 100vw;
  flex-grow: 1;
}

.label-formularios {
  height: 40px;
  letter-spacing: 0.05em;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  color: $cafe-embajadores;
  background-color: #f3f3f3;
  padding-top: 4px;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 4px;
}

.label-envio-documentos {
  text-align: justify;
  float: left;
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  color: $color-primario;
}

.parrafo-envio-documentos {
  text-align: justify;
  float: left;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  color: $color-primario;
}

.icono-subir-archivo {
  color: $color-primario;
}

.boton-eliminar {
  width: 45%;
}

.boton-descargar {
  margin-right: 10px;
  width: 45%;
}

.layer-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  position: relative;
  height: 80vh;
  z-index: 5;
  background: #ffffff;
}

.layer-loader-spinner,
.layer-loader-spinner:before,
.layer-loader-spinner:after {
  background: $color-primario;
  -webkit-animation: load1 1s infinite ease-in-out;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 4em;
}

.layer-loader-spinner {
  color: $color-primario;
  text-indent: -9999em;
  margin: 88px auto;
  position: relative;
  font-size: 11px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

.layer-loader-spinner:before,
.layer-loader-spinner:after {
  position: absolute;
  top: 0;
  content: "";
}

.layer-loader-spinner:before {
  left: -1.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.layer-loader-spinner:after {
  left: 1.5em;
}

.grupo-boton__deshabilitado {
  opacity: 0.5;
  cursor: not-allowed;
}

@-webkit-keyframes load1 {

  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }

  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}

@keyframes load1 {

  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }

  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
</style>
